import { render, staticRenderFns } from "./guidancePaperInfo.vue?vue&type=template&id=76cc8cac&scoped=true&"
import script from "./guidancePaperInfo.vue?vue&type=script&lang=js&"
export * from "./guidancePaperInfo.vue?vue&type=script&lang=js&"
import style0 from "./guidancePaperInfo.vue?vue&type=style&index=0&id=76cc8cac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76cc8cac",
  null
  
)

export default component.exports